import _ from 'lodash';

export const convertNumberInput = (number: string | number | undefined) => {
  if (number === '0' || number === 0) {
    return 0;
  }
  if (!Number(number)) {
    return undefined;
  }
  return Number(number);
};

export const convertNumbersInput = (attrValue?: string | number[]) => {
  if (_.isArray(attrValue) && _.every(attrValue, _.isNumber)) {
    return attrValue;
  }
  if (_.isNil(attrValue)) {
    return [];
  }
  if (_.isString(attrValue) && attrValue.length > 0) {
    return attrValue.split(',').map(_.toNumber);
  }
  return [];
};
